namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class FormFollowUpVariableEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "{form_template}", text: "Form Template" });
            this.addItem({ id: "{order_id}", text: "Order Id" });
            this.addItem({ id: "{order_date}", text: "Order Date" });
            this.addItem({ id: "{customer_name}", text: "Customer Name" });
            this.addItem({ id: "{customer_phone}", text: "Customer Phone" });
            this.addItem({ id: "{customer_email}", text: "Customer Email" });
            this.addItem({ id: "{customer_note}", text: "Customer Note" });
            this.addItem({ id: "{customer_address}", text: "Customer Address" });
            this.addItem({ id: "{customer_country}", text: "Customer Country" });
            this.addItem({ id: "{customer_state}", text: "Customer State" });
            this.addItem({ id: "{customer_city}", text: "Customer City" });
            this.addItem({ id: "{product_name}", text: "Product Name" });
            this.addItem({ id: "{product_price}", text: "Product Price" });
            this.addItem({ id: "{quantity}", text: "Product Quantity" });
            this.addItem({ id: "{total_price}", text: "Total Price" });
            this.addItem({ id: "{coupon_code}", text: "Coupon Code" });
            this.addItem({ id: "{payment_method}", text: "Payment Method" });
            this.addItem({ id: "{bank_accounts}", text: "Bank Accounts" });
            this.addItem({ id: "{additional_cost_label}", text: "Additional Cost Label" });
            this.addItem({ id: "{additional_cost}", text: "Additional Cost" });
            this.addItem({ id: "{reduction_cost_label}", text: "Reduction Cost Label" });
            this.addItem({ id: "{reduction_cost}", text: "Reduction Cost" });
            this.addItem({ id: "{grand_total}", text: "Grand Total" });
        }
    }
}